import { number, object, string } from "yup"

export default object({
  id: string().required(),
  domainId: string().required(),
  dailyLimit: number().required(),
})
